import React from 'react';
import { H3 } from '@citygross/typography';
import { FormControlWrapper, FormControlElementWrapper } from './FormControl.styles.js';
var TScreenWidth;

(function (TScreenWidth) {
  TScreenWidth["1/2"] = "calc(50% - 12px)";
  TScreenWidth["1/3"] = "calc(33% - 12px)";
  TScreenWidth["1/4"] = "calc(25% - 12px)";
})(TScreenWidth || (TScreenWidth = {})); // eslint-disable-next-line no-empty-pattern


function FormControl(_a) {
  var title = _a.title,
      children = _a.children,
      errorMessage = _a.errorMessage,
      _b = _a.isValid,
      isValid = _b === void 0 ? true : _b,
      screenWidth = _a.screenWidth;
  return React.createElement(FormControlWrapper, null, title && React.createElement(FormControlElementWrapper, null, React.createElement(H3, null, title)), React.createElement(FormControlElementWrapper, {
    screenWidth: screenWidth
  }, children), errorMessage && !isValid && errorMessage);
}

export { FormControl, TScreenWidth };